export const goblinAttack = new Image();
goblinAttack.src = "assets/characterSprites/goblin/Attack.png";
goblinAttack.width = 1200/8;
goblinAttack.height = 150/1;
goblinAttack.yOffset = 40;
goblinAttack.xOffset = 100;
goblinAttack.cycleLoop = [0,1,2,3,4,5,6,7];